import { createSelector } from 'reselect';
import { hasValue } from 'src/utils/utils';
import { ApplicationState, getSubState } from '../types';

const slice = getSubState<
  ApplicationState,
  ApplicationState['executeAutoExchange']
>('executeAutoExchange');

export const getIsLoading = createSelector(
  [slice],
  ({ isLoading }) => isLoading
);
export const getIsLoaded = createSelector([slice], ({ isLoaded }) => isLoaded);
export const getTransactions = createSelector(
  [slice],
  ({ transactions }) => transactions
);
export const getValidationFailed = createSelector(
  [slice],
  ({ validationFailed }) => validationFailed
);
export const getHasFailed = createSelector(
  [slice],
  ({ hasFailed }) => hasFailed
);
export const getConfirmationNumber = createSelector(
  [slice],
  ({ confirmationNumber }) => confirmationNumber
);

export const shouldChangeURL = createSelector(
  [getIsLoading, getIsLoaded, getTransactions, getValidationFailed],
  (
    isExecuteExchangeLoading,
    isExecuteExchangeLoaded,
    transactions,
    isValidationFailed
  ) => {
    //debugger;
    return (
      !isExecuteExchangeLoading &&
      isExecuteExchangeLoaded &&
      hasValue(transactions) &&
      !isValidationFailed
    );
  }
);
